import { render, staticRenderFns } from "./full-screen.vue?vue&type=template&id=fae1a3e4&"
import script from "./full-screen.vue?vue&type=script&lang=js&"
export * from "./full-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports